import type { ReactNode } from "react";
import {
  ListBoxItem as ReactAriaListBoxItem,
  type ListBoxItemProps,
} from "react-aria-components";
import { cn } from "../../../utilities/tailwind";

export type ListBoxItemProperties = ListBoxItemProps & {
  className?: string | undefined;
  children: ReactNode;
  useInteractiveCss?: boolean | undefined;
};
export const ListBoxItem = ({
  className = "",
  children,
  useInteractiveCss = true,
  ...properties
}: ListBoxItemProperties) => {
  const twClassname = cn(
    "group/list-item flex min-h-8 cursor-pointer items-center px-6 py-2 text-royal-blue",
    {
      "hover:bg-royal-blue hover:text-white data-focused:bg-royal-blue data-focused:text-white data-[disabled=true]:pointer-events-none":
        useInteractiveCss,
    },
    className,
  );

  return (
    <ReactAriaListBoxItem className={twClassname} {...properties}>
      {children}
    </ReactAriaListBoxItem>
  );
};
ListBoxItem.displayName = "InputComboBox.ListBoxItem";
